module.exports = __webpack_public_path__ + "annualreview2018/static/img/ceo-introduction@2x.1705ff3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/covers/ceo-introduction@2x.png
// module id = hxg1
// module chunks = 10